import { useLanguage } from '../LanguageContext';
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

import DataTable from './DataTable';

const DetailsModal = ({ open, onClose, playerBans, selectedPlayerName, onUnban }) => {
  const { t, locale } = useLanguage();
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) {
      return t("N/A");
    }
    const date = new Date(dateTimeString);
    return date.toLocaleString(locale);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={false} sx={{ '& .MuiDialog-paper': { width: 'calc(100% - 32px)', maxWidth: 1800, mx: 2 } }}>
      <DialogTitle>
        {t("Details for {name} (Total Bans: {count})", { name: selectedPlayerName, count: playerBans.length })}
      </DialogTitle>
      <DialogContent>
        <DataTable key={`${open}-${selectedPlayerName}`} label="ban history" rows={playerBans} rowKey={ban => `${ban.player_identity}-${ban.ban_start}`} columns={[
          { key: 'player_name', label: t("Player name") },
          { key: 'player_identity', label: t("Player ID"), mono: true },
          { key: 'admin_name', label: t("Admin") },
          { key: 'ban_reason', label: t("Reason") },
          { key: 'is_active', label: t("Status"), value: ban => ban.is_active ? t("Active") : t("Expired") },
          { key: 'ban_start', label: t("Issued time"), value: ban => formatDateTime(ban.ban_start), sortValue: ban => new Date(ban.ban_start).getTime() },
          { key: 'ban_end', label: t("End time"), value: ban => ban.ban_end ? formatDateTime(ban.ban_end) : t("Permanent"), sortValue: ban => ban.ban_end ? new Date(ban.ban_end).getTime() : Number.MAX_SAFE_INTEGER },
        ]} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">{t("Close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailsModal;
